module.exports = __webpack_public_path__ + "media/images/yw_title-c841f2754b3849f3d27d851c7ebe1ac0.png";